import { SketchPickerStylesProps } from 'react-color/lib/components/sketch/Sketch';
import { Classes } from 'reactcss';

export const theme: Partial<Classes<SketchPickerStylesProps>> = {
  default: {
    picker: {
      background: 'transparent',
      paddingTop: '0px',
      color: 'var(--g-typography-primary)',
      boxShadow: 'none',
    },
  },
};
